module.exports = __webpack_public_path__ + "static/media/black-logo.72b98dba.png";